import React, { FC, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import { GameReports as GameReportsType, CommonGCGame } from '../../../../types';

import { GameReportLink, LinksWrapper } from './styles';

type Props = {
    game: CommonGCGame;
    reports?: GameReportsType;
};

type TeamProps = {
    team: string;
};

const TeamTimeOnIce: FC<TeamProps> = ({ team }) => (
    <FormattedMessage
        defaultMessage="Time On Ice: {team}"
        description="Describes a report of time on ice for the given team"
        values={{ team }}
    />
);

const getGameReportLink = (reportLink: string | undefined, linkText: ReactNode): ReactNode =>
    reportLink && <GameReportLink href={decodeURIComponent(reportLink)}>{linkText}</GameReportLink>;

const GameReports: FC<Props> = ({ game, reports }) => {
    return reports && game ? (
        <LinksWrapper>
            {getGameReportLink(
                reports.gameSummary,
                <FormattedMessage defaultMessage="Game Summary" description="Describes a game summary report" />
            )}
            {getGameReportLink(
                reports.eventSummary,
                <FormattedMessage defaultMessage="Event Summary" description="Describes an event summary report" />
            )}
            {getGameReportLink(
                reports.playByPlay,
                <FormattedMessage defaultMessage="Full Play-By-Play" description="Describes a full game play-by-play" />
            )}
            {getGameReportLink(
                reports.faceoffComparison,
                <FormattedMessage
                    defaultMessage="Face-off Comparison"
                    description="Describes a face-off comparison between teams"
                />
            )}
            {getGameReportLink(
                reports.faceoffSummary,
                <FormattedMessage
                    defaultMessage="Face-off Summary"
                    description="Describes a summary of face-offs in a game"
                />
            )}
            {getGameReportLink(reports.toiAway, <TeamTimeOnIce team={game.awayTeam.abbrev} />)}
            {getGameReportLink(reports.toiHome, <TeamTimeOnIce team={game.homeTeam.abbrev} />)}
            {getGameReportLink(
                reports.shotSummary,
                <FormattedMessage defaultMessage="Shot Report" description="Describes a game shot report" />
            )}
            {getGameReportLink(
                reports.shiftChart,
                <FormattedMessage defaultMessage="Shift Chart" description="Describes a game shift chart" />
            )}
            {getGameReportLink(
                reports.shootoutSummary,
                <FormattedMessage defaultMessage="Shootout Report" description="Describes a game shootout report" />
            )}
            {getGameReportLink(
                reports.rosters,
                <FormattedMessage defaultMessage="Roster Report" description="Describes a game roster report" />
            )}
        </LinksWrapper>
    ) : null;
};

export default GameReports;
